var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27030_230965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6001 16C32.6001 7.16344 25.4367 0 16.6001 0C7.76354 0 0.600098 7.16344 0.600098 16C0.600098 24.8366 7.76354 32 16.6001 32C25.4367 32 32.6001 24.8366 32.6001 16Z",
    fill: "url(#paint0_linear_27030_230965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9667 18.1L20.6167 12.45C20.7501 12.3167 20.9084 12.25 21.0917 12.25C21.2751 12.25 21.4334 12.3167 21.5667 12.45C21.7001 12.5833 21.7667 12.7417 21.7667 12.925C21.7667 13.1083 21.7001 13.2667 21.5667 13.4L15.4334 19.5333C15.3001 19.6667 15.1445 19.7333 14.9667 19.7333C14.789 19.7333 14.6334 19.6667 14.5001 19.5333L11.6334 16.6667C11.5001 16.5333 11.4362 16.375 11.4417 16.1917C11.4473 16.0083 11.5167 15.85 11.6501 15.7167C11.7834 15.5833 11.9417 15.5167 12.1251 15.5167C12.3084 15.5167 12.4667 15.5833 12.6001 15.7167L14.9667 18.1Z",
    fill: "#F7F7F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27030_230965",
    x1: 16.6001,
    y1: 0,
    x2: 16.6001,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E7D32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF598"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27030_230965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.600098)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.be44483a9fc38fe8f28754eaaa0ceb8c.svg";
export { ForwardRef as ReactComponent };